/**
 * API Client Factory
 *
 * ⚠️ Uses Next.js runtime utilities (next-runtime-env)
 * Safe for:
 * - Next.js frontend code
 * - Next.js Server Components
 *
 * NOT safe for:
 * - Backend/API code (NestJS/VDP)
 *
 * Backend should use HttpClient directly with SDK.configuration
 */
import {getApiUrl} from "@/shared/utils/env";
import {isServer} from "@/shared/utils/runtime";

import {HttpClient, type HttpClientConfig, type HttpClientInstance} from "./http-client";

/**
 * Create pre-configured HTTP client for API requests
 * Uses getApiUrl() for baseUrl and default JSON headers
 * Note: fetch cannot be overridden in createApiClient (use HttpClient directly for testing)
 */
export function createApiClient(config?: Omit<HttpClientConfig, "baseUrl" | "fetch">): HttpClientInstance {
    return HttpClient({
        baseUrl: getApiUrl(),
        defaultHeaders: {
            "Content-Type": "application/json",
        },
        isServer: isServer(),
        ...config,
    });
}
